import { useFormikContext } from 'formik'

import { ThailandAddressType } from '@components/interfaces/AddressSearchSelect'
import { WriterFormType } from '@models/writer/WriterFormType'
import { AddressProps, WithAddressProps } from './interface'

export function withAddress(Component: React.FC<AddressProps>) {
  function WithAddress({ residenceOptions, countryOptions }: WithAddressProps) {
    const { values, setFieldValue } = useFormikContext<WriterFormType>()

    function handleAddressChange(data: ThailandAddressType) {
      setFieldValue('province', data.province)
      setFieldValue('district', data.amphoe)
      setFieldValue('subDistrict', data.district)
      setFieldValue('postcode', String(data.zipcode))
    }

    const componentProps = {
      values,
      residenceOptions,
      countryOptions,
      handleAddressChange,
    }
    return <Component {...componentProps} />
  }

  return WithAddress
}
